/* ═══════════════════════════════════════════════════════════════
   IDProductSource — Theme JavaScript
   ═══════════════════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', () => {
  initMegaMenu();
  initMobileNav();
  initMobileSearch();
  initAccordions();
  initGallery();
  formatPrices();
  initOptionImageZoom();
  initColorSwatches();
});

/* ── MEGA MENU ─────────────────────────────────────────────── */
function initMegaMenu() {
  const navItems = document.querySelectorAll('.nav-item--mega, .nav-item--flyout');
  let closeTimeout = null;

  navItems.forEach(item => {
    const panel = item.querySelector('.mega, .flyout');
    if (!panel) return;

    // Desktop: hover with delay to prevent accidental close
    item.addEventListener('mouseenter', () => {
      clearTimeout(closeTimeout);
      // Close all others
      navItems.forEach(other => {
        if (other !== item) {
          other.classList.remove('is-open');
          const link = other.querySelector('.nav-link');
          if (link) link.setAttribute('aria-expanded', 'false');
        }
      });
      item.classList.add('is-open');
      const link = item.querySelector('.nav-link');
      if (link) link.setAttribute('aria-expanded', 'true');
    });

    item.addEventListener('mouseleave', () => {
      closeTimeout = setTimeout(() => {
        item.classList.remove('is-open');
        const link = item.querySelector('.nav-link');
        if (link) link.setAttribute('aria-expanded', 'false');
      }, 120);
    });

    // Keep open when hovering the panel itself
    panel.addEventListener('mouseenter', () => clearTimeout(closeTimeout));
    panel.addEventListener('mouseleave', () => {
      closeTimeout = setTimeout(() => {
        item.classList.remove('is-open');
        const link = item.querySelector('.nav-link');
        if (link) link.setAttribute('aria-expanded', 'false');
      }, 120);
    });
  });

  // Close on escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      navItems.forEach(item => {
        item.classList.remove('is-open');
        const link = item.querySelector('.nav-link');
        if (link) link.setAttribute('aria-expanded', 'false');
      });
    }
  });
}

/* ── MOBILE NAV (dropdown toggle) ─────────────────────────── */
function initMobileNav() {
  var toggles = document.querySelectorAll('.mobile-nav-toggle');
  var nav = document.querySelector('.mobile-nav');
  if (!toggles.length || !nav) return;

  toggles.forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      var open = nav.classList.toggle('is-open');
      nav.setAttribute('aria-hidden', open ? 'false' : 'true');
      toggles.forEach(function(t) {
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) t.classList.add('is-active');
        else t.classList.remove('is-active');
      });
    });
  });

  // Accordion sub-menus
  nav.querySelectorAll('.mobile-nav__toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      var sub = btn.nextElementSibling;
      if (!sub) return;

      // Close sibling sub-menus at the same level
      var parent = btn.parentElement.parentElement;
      if (parent) {
        parent.querySelectorAll(':scope > .mobile-nav__item > .mobile-nav__toggle, :scope > .has-children > .mobile-nav__toggle').forEach(function(sibling) {
          if (sibling !== btn) {
            sibling.setAttribute('aria-expanded', 'false');
            var sibSub = sibling.nextElementSibling;
            if (sibSub) sibSub.classList.remove('is-open');
          }
        });
      }

      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      sub.classList.toggle('is-open', !expanded);
    });
  });
}

/* ── MOBILE SEARCH TOGGLE ─────────────────────────────────── */
function initMobileSearch() {
  var toggle = document.querySelector('.mobile-search-toggle');
  var bar = document.querySelector('.mobile-search');
  if (!toggle || !bar) return;

  toggle.addEventListener('click', function() {
    var open = bar.classList.toggle('is-open');
    bar.setAttribute('aria-hidden', open ? 'false' : 'true');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      var input = bar.querySelector('input');
      if (input) input.focus();
    }
  });
}

/* ── ACCORDIONS ────────────────────────────────────────────── */
function initAccordions() {
  document.querySelectorAll('.accordion__trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const expanded = trigger.getAttribute('aria-expanded') === 'true';
      const content = trigger.nextElementSibling;
      if (!content) return;

      // Independent panels: toggling one never closes the others (multi-open).
      const isEsd = trigger.textContent.indexOf('Estimated Ship Date') !== -1;

      trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      content.classList.toggle('is-open', !expanded);

      // Auto-calculate and flash event field when ESD opens
      if (isEsd && !expanded) {
        const esdBtn = document.getElementById('esd-btn');
        if (esdBtn) setTimeout(() => esdBtn.click(), 150);
        const eventField = document.getElementById('esd-event');
        if (eventField) {
          eventField.classList.add('esd-flash');
          setTimeout(() => eventField.classList.remove('esd-flash'), 2400);
        }
      }
    });
  });

  // Auto-open first accordion item (Overview)
  const firstTrigger = document.querySelector('.accordion__trigger');
  if (firstTrigger) {
    firstTrigger.setAttribute('aria-expanded', 'true');
    const firstContent = firstTrigger.nextElementSibling;
    if (firstContent) firstContent.classList.add('is-open');
  }
}

/* ── PRICE FORMATTER ───────────────────────────────────────── */
// Ensures all metafield-sourced prices render as $x.xx (e.g. $2.7 → $2.70)
function formatPrices() {
  const selectors = [
    '.product-card__pricing-cell--price',  // collection card hover overlay
    '.product-card__price-amount',          // collection card "as low as"
    '.pricing-grid__cell--price',           // PDP pricing grid
    '.pricing-grid__code-label strong',     // PDP price code (not a price but skip non-numeric)
  ];

  document.querySelectorAll(selectors.slice(0, 3).join(',')).forEach(el => {
    const raw = el.textContent.trim().replace(/[^0-9.]/g, '');
    const num = parseFloat(raw);
    if (!isNaN(num)) {
      el.textContent = '$' + num.toFixed(2);
    }
  });
}

/* ── GALLERY THUMBNAIL SWITCHER ────────────────────────────── */
function initGallery() {
  const mainImage = document.querySelector('.pdp__main-image');
  const thumbs = document.querySelectorAll('.pdp__thumb');
  const zoomWrap = document.querySelector('.pdp__zoom-wrap');

  if (!mainImage || thumbs.length === 0) return;

  // Create color label element
  var colorLabel = document.createElement('div');
  colorLabel.className = 'pdp__color-label';
  if (zoomWrap) zoomWrap.appendChild(colorLabel);

  function extractColorName(alt) {
    if (!alt) return '';
    // Alt format from upload: "SKU - Color Name" (e.g. "FPL-1 - D Blue")
    var dashIdx = alt.indexOf(' - ');
    if (dashIdx === -1) return '';
    var raw = alt.substring(dashIdx + 3).trim();
    if (!raw) return '';
    // Expand common abbreviations: DBlue -> Dark Blue, LGreen -> Light Green, etc.
    raw = raw
      .replace(/^D\s?Blue$/i, 'Dark Blue')
      .replace(/^D\s?Gray$/i, 'Dark Gray')
      .replace(/^D\s?Green$/i, 'Dark Green')
      .replace(/^L\s?Blue$/i, 'Light Blue')
      .replace(/^L\s?Green$/i, 'Light Green')
      .replace(/^N\s?Blue$/i, 'Navy Blue')
      .replace(/^P\s?Blue$/i, 'Process Blue')
      .replace(/^R\s?Blue$/i, 'Royal Blue')
      .replace(/^RO\s?Blue$/i, 'Royal Blue')
      .replace(/^RO\s?Orange$/i, 'Red Orange')
      .replace(/^H\s?Pink$/i, 'Hot Pink')
      .replace(/^J\s?Green$/i, 'Jade Green')
      .replace(/^K\s?Green$/i, 'Kelly Green')
      .replace(/^3Q$/i, '3/4 View');
    return raw;
  }

  function showColorLabel(alt) {
    var color = extractColorName(alt);
    if (color) {
      colorLabel.textContent = color;
      colorLabel.style.display = 'block';
    } else {
      colorLabel.style.display = 'none';
    }
  }

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      mainImage.src = thumb.dataset.full || thumb.src;
      mainImage.alt = thumb.alt || '';
      if (zoomWrap && thumb.dataset.zoom) {
        zoomWrap.setAttribute('data-zoom-src', thumb.dataset.zoom);
      }
      showColorLabel(thumb.alt);
    });
  });

  // Mark first thumb as active
  thumbs[0].classList.add('is-active');
  showColorLabel(thumbs[0].alt);
}

/* ── Option Image Hover Zoom ─────────────────────────────── */
function initOptionImageZoom() {
  var lightbox = null;
  var boxImg = null;
  var label = null;

  function build() {
    lightbox = document.createElement('div');
    lightbox.className = 'opt-lightbox';
    lightbox.setAttribute('aria-hidden', 'true');

    var box = document.createElement('div');
    box.className = 'opt-lightbox__box';

    var closeBtn = document.createElement('button');
    closeBtn.className = 'opt-lightbox__close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML = '<i class="fa-solid fa-xmark"></i>';

    boxImg = document.createElement('img');
    boxImg.className = 'opt-lightbox__img';

    label = document.createElement('div');
    label.className = 'opt-lightbox__label';

    box.appendChild(closeBtn);
    box.appendChild(boxImg);
    box.appendChild(label);
    lightbox.appendChild(box);
    document.body.appendChild(lightbox);

    closeBtn.addEventListener('click', hide);
    lightbox.addEventListener('click', function(e) { if (e.target === lightbox) hide(); });
  }

  function show(imgEl) {
    if (!lightbox) build();
    var nameInner = imgEl.closest('.options-table__name-inner');
    var optionName = '';
    if (nameInner) {
      var span = nameInner.querySelector('.options-table__opt-name');
      if (span) optionName = span.textContent.trim();
    }
    boxImg.src = imgEl.getAttribute('data-full') || imgEl.src; // the thumbnail itself is a small copy
    boxImg.alt = imgEl.alt || '';
    label.textContent = optionName || imgEl.alt || '';
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function hide() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // Click (or keyboard) on a thumbnail opens the lightbox.
  document.addEventListener('click', function(e) {
    var thumb = e.target.closest('.options-table__thumb');
    if (!thumb) return;
    var img = thumb.querySelector('.options-table__img');
    if (img) show(img);
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      var thumb = document.activeElement && document.activeElement.closest && document.activeElement.closest('.options-table__thumb');
      if (thumb) {
        e.preventDefault();
        var img = thumb.querySelector('.options-table__img');
        if (img) show(img);
      }
    }
    if (e.key === 'Escape') hide();
  });
}

/* ── COLLECTION-CARD COLOR SWATCHES (Option B — on the image) ───
   Hover a swatch to preview its color photo; click/tap to commit it. Document-level delegation
   so it also covers cards injected by the products-per-page re-render + search results. The
   swatches live inside the card's image <a>, so click preventDefault stops navigation (a tap on
   a swatch swaps the photo instead of opening the product; a tap anywhere else still opens it). */
function initColorSwatches() {
  function cardImg(sw) { var c = sw.closest('.product-card'); return c ? c.querySelector('.product-card__image') : null; }
  function ensureInit(img) {
    if (!img.getAttribute('data-orig')) { img.setAttribute('data-orig', img.getAttribute('src') || ''); img.removeAttribute('srcset'); }
  }
  function swFrom(e) { return (e.target && e.target.closest) ? e.target.closest('.product-card__sw') : null; }

  // Row-based hover: manage the whole .product-card__swatches area, so moving between dots (or over
  // the +N chip / gaps) never flickers the image or restores the pricing overlay — that only happens
  // when the cursor truly LEAVES the row (relatedTarget outside it).
  // A card showing a Logo Preview (.pv-card, snippets/virtual-sample-overlay.liquid) owns its image —
  // swatches stand down on THAT card only; cards without preview data keep working while it's on.
  function pvOwns(el) { var c = el && el.closest ? el.closest('.product-card') : null; return !!(c && c.classList.contains('pv-card')); }
  document.addEventListener('mouseover', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var row = t.closest('.product-card__swatches'); if (!row) return;
    if (pvOwns(row)) return; // Logo Preview owns this card's image
    var card = row.closest('.product-card'); if (card) card.classList.add('is-swatch-hover');
    var sw = t.closest('.product-card__sw'); if (!sw) return;
    var url = sw.getAttribute('data-img'); if (!url) return;
    var img = card ? card.querySelector('.product-card__image') : null; if (!img) return;
    ensureInit(img); img.src = url;
  });
  document.addEventListener('mouseout', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var row = t.closest('.product-card__swatches'); if (!row) return;
    if (pvOwns(row)) return; // Logo Preview owns this card's image
    if (e.relatedTarget && row.contains(e.relatedTarget)) return; // still inside the row → keep state
    var card = row.closest('.product-card'); if (card) card.classList.remove('is-swatch-hover');
    var img = card ? card.querySelector('.product-card__image') : null;
    if (img) { var back = img.getAttribute('data-committed') || img.getAttribute('data-orig'); if (back) img.src = back; }
  });
  document.addEventListener('click', function (e) {
    var sw = swFrom(e); if (!sw) return;
    if (pvOwns(sw)) return; // Logo Preview owns this card's image
    var url = sw.getAttribute('data-img'); if (!url) return;
    e.preventDefault(); e.stopPropagation();
    var img = cardImg(sw); if (!img) return;
    ensureInit(img);
    img.setAttribute('data-committed', url); img.src = url;
    var card = sw.closest('.product-card');
    if (card) { var all = card.querySelectorAll('.product-card__sw'); for (var i = 0; i < all.length; i++) all[i].classList.remove('is-active'); }
    sw.classList.add('is-active');
  });
}

/* ── In-page dialogs — styled replacements for native alert/confirm/prompt ──────
   Usage (Promise-based):
     IDPSDialog.alert('Saved.')                         -> resolves when dismissed
     IDPSDialog.confirm('Delete this?').then(ok => …)   -> resolves true/false
     IDPSDialog.prompt('Email:', '').then(val => …)     -> resolves string or null (Cancel)
   Options (2nd/3rd arg object): {title, okLabel, cancelLabel, danger:true, placeholder}
   Available globally on window.IDPSDialog so every section can share one styled modal. */
window.IDPSDialog = (function () {
  var root = null, keyH = null, current = null;
  function ensure() {
    if (root) return;
    var st = document.createElement('style');
    st.textContent =
      '.idlg{position:fixed;inset:0;z-index:100000;display:none;align-items:center;justify-content:center;padding:18px;font-family:"DM Sans",-apple-system,Segoe UI,Roboto,sans-serif;}' +
      '.idlg.is-open{display:flex;}' +
      '.idlg__ov{position:absolute;inset:0;background:rgba(15,30,55,.5);}' +
      '.idlg__panel{position:relative;background:#fff;border-radius:16px;max-width:420px;width:100%;padding:22px 22px 18px;box-shadow:0 30px 80px rgba(10,25,50,.35);animation:idlgpop .16s ease;}' +
      '@keyframes idlgpop{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}' +
      '.idlg__title{font-family:"Montserrat",sans-serif;font-weight:800;font-size:17px;color:#15233b;margin:0 0 6px;}' +
      '.idlg__msg{font-size:14.5px;color:#3a4654;line-height:1.5;white-space:pre-wrap;}' +
      '.idlg__input{width:100%;box-sizing:border-box;margin-top:12px;border:1px solid #dbe3ec;border-radius:9px;padding:10px 12px;font-size:14px;font-family:inherit;color:#15233b;background:#fbfdff;}' +
      '.idlg__input:focus{outline:none;border-color:#1a5fa8;box-shadow:0 0 0 3px rgba(26,95,168,.13);background:#fff;}' +
      '.idlg__input[hidden]{display:none;}' +
      '.idlg__actions{display:flex;justify-content:flex-end;gap:10px;margin-top:18px;}' +
      '.idlg__btn{border:1px solid #dbe3ec;background:#fff;color:#15233b;font-family:"Montserrat",sans-serif;font-weight:700;font-size:13.5px;padding:10px 18px;border-radius:10px;cursor:pointer;}' +
      '.idlg__btn--ghost:hover{background:#f4f7fb;}' +
      '.idlg__btn--primary{background:#1a5fa8;border-color:#1a5fa8;color:#fff;}.idlg__btn--primary:hover{background:#16518f;}' +
      '.idlg__btn--danger{background:#dc2626;border-color:#dc2626;color:#fff;}.idlg__btn--danger:hover{background:#b91c1c;}' +
      '.idlg__btn--cancel[hidden]{display:none;}';
    document.head.appendChild(st);
    root = document.createElement('div');
    root.className = 'idlg';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.innerHTML =
      '<div class="idlg__ov" data-idlg-cancel></div>' +
      '<div class="idlg__panel">' +
        '<div class="idlg__title" id="idlg-title" hidden></div>' +
        '<div class="idlg__msg" id="idlg-msg"></div>' +
        '<input class="idlg__input" id="idlg-input" hidden>' +
        '<div class="idlg__actions">' +
          '<button type="button" class="idlg__btn idlg__btn--ghost idlg__btn--cancel" id="idlg-cancel" data-idlg-cancel>Cancel</button>' +
          '<button type="button" class="idlg__btn idlg__btn--primary" id="idlg-ok">OK</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(root);
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-idlg-cancel]')) resolve(false);
      else if (e.target.closest('#idlg-ok')) resolve(true);
    });
  }
  function id(x) { return document.getElementById(x); }
  function resolve(ok) {
    if (!current) return;
    var c = current; current = null;
    root.classList.remove('is-open');
    if (keyH) { document.removeEventListener('keydown', keyH, true); keyH = null; }
    var val = c.type === 'prompt' ? (ok ? (id('idlg-input').value || '') : null) : (c.type === 'confirm' ? !!ok : undefined);
    c.done(val);
  }
  function open(o) {
    ensure();
    return new Promise(function (done) {
      current = { type: o.type, done: done };
      var titleEl = id('idlg-title'), inp = id('idlg-input'), cancelBtn = id('idlg-cancel'), okBtn = id('idlg-ok');
      if (o.title) { titleEl.textContent = o.title; titleEl.hidden = false; } else { titleEl.hidden = true; }
      id('idlg-msg').textContent = o.msg == null ? '' : String(o.msg);
      if (o.type === 'prompt') { inp.hidden = false; inp.value = o.def == null ? '' : String(o.def); inp.placeholder = o.placeholder || ''; }
      else { inp.hidden = true; }
      cancelBtn.hidden = (o.type === 'alert');
      cancelBtn.textContent = o.cancelLabel || 'Cancel';
      okBtn.textContent = o.okLabel || (o.type === 'alert' ? 'OK' : (o.type === 'confirm' ? 'Confirm' : 'OK'));
      okBtn.className = 'idlg__btn ' + (o.danger ? 'idlg__btn--danger' : 'idlg__btn--primary');
      root.classList.add('is-open');
      keyH = function (e) {
        if (e.key === 'Escape') { e.preventDefault(); resolve(false); }
        else if (e.key === 'Enter' && o.type !== 'prompt') { e.preventDefault(); resolve(true); }
        else if (e.key === 'Enter' && o.type === 'prompt' && document.activeElement === inp) { e.preventDefault(); resolve(true); }
      };
      document.addEventListener('keydown', keyH, true);
      setTimeout(function () { (o.type === 'prompt' ? inp : okBtn).focus(); }, 30);
    });
  }
  return {
    alert: function (msg, o) { o = o || {}; o.type = 'alert'; o.msg = msg; return open(o); },
    confirm: function (msg, o) { o = o || {}; o.type = 'confirm'; o.msg = msg; return open(o); },
    prompt: function (msg, def, o) { o = o || {}; o.type = 'prompt'; o.msg = msg; o.def = def; return open(o); }
  };
})();

/* Hero photo walls (snippets/page-hero.liquid, sections/main-article.liquid; styles in page-hero.css).
   The tiles are decoration, so their photos (data-wall-src) only start loading after the page has finished
   loading, then fade in. Before this they downloaded alongside the main picture (36 tiles on a blog post)
   and held up the first view. SEO speed pass 2026-10-15. Test: scripts/tests/test-speed-loading.js */
(function initHeroWalls() {
  function run() {
    var imgs = document.querySelectorAll('img[data-wall-src]');
    for (var i = 0; i < imgs.length; i++) {
      (function (im) {
        var done = function () { im.classList.add('is-in'); };
        im.addEventListener('load', done);
        im.addEventListener('error', done);
        im.src = im.getAttribute('data-wall-src');
        im.removeAttribute('data-wall-src');
      })(imgs[i]);
    }
  }
  function later() {
    if ('requestIdleCallback' in window) window.requestIdleCallback(run, { timeout: 1200 });
    else setTimeout(run, 150);
  }
  if (document.readyState === 'complete') later();
  else window.addEventListener('load', later);
})();
